<template>
  <div class="purchaseOrder rel flex font">
    <div class="body abs flex">
      <!-- 第一页面 -->
      <div class="firstPage w100p flex aic jc-sb">
        <div class="leftBody">
          <div class="purOrderBox pl-15 pt-15 pr-15">
            <div class="topInfo flex aic jc-sb">
              <div
                class="leftTitle"
                style="width:100%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;cursor:pointer"
              >
                <!-- <span class="number f18 fwb">{{ purOrderObj.purOrderNumber }}</span> -->
                <span class="f14">{{ $t('Order.orderPurchaserOrders') }}</span>
              </div>
              <div class="rightAction flex aic jc-end">
                <el-input
                  v-model="searchPurOrderObj.Keyword"
                  @input="inputKeyword1"
                  clearable
                  class="w20p"
                  :placeholder="$t('Order.orderSearchPurOrderList')"
                  :prefix-icon="Search"
                  style="width: 306px;height:24px"
                />
                <el-button
                  @click="getPurchaseOrderList"
                  plain
                  style="height:24px;width: 24px;border: 1px solid #CAD2D9;margin-left: 8px;"
                >
                  <i
                    class="iconfont icon-shuaxin fwb f12"
                    :style="purOrderObj.loading ? 'animation: loading-rotate 1s linear infinite;' : ''"
                  ></i>
                </el-button>
              </div>
            </div>
            <div class="purOrderTable mt-10">
              <el-table
                ref="purOrderTableRef"
                :data="purOrderObj.purOrderList"
                v-loading="purOrderObj.loading"
                v-el-table-infinite-scroll="getPurchaseOrderList1"
                highlight-current-row
                @current-change="handleCurrentChange"
                @selection-change="handleSelectionChange"
                border
                :header-cell-style="{
                                  'background-color': '#F2F4F7', 'font-weight': 'bold',
                                  'height': '40px', 'fontSize': '14px'
                              }"
                height="100%"
              >
                <template #empty>
                  <Empty :size="120" :color="'#999999'">
                    <span class="f20 mt-30" style="color:#999999">No data</span>
                  </Empty>
                </template>
                <el-table-column type="selection" width="40" align="center" />
                <!-- <el-table-column type="selection" width="35" /> -->
                <el-table-column label="ID" prop="Purchaseordername" show-overflow-tooltip>
                  <template #header>
                    <el-dropdown trigger="click">
                      <span class="ovhidden1 flex mt-5 f333">ID</span>
                    </el-dropdown>
                  </template>
                  <template #default="{ row }">
                    <span
                      @click="getPurOrderID(row)"
                      style="color: #3370ff;text-decoration:underline;cursor: pointer;"
                    >{{ row.Purchaseordername }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="state_text" show-overflow-tooltip>
                  <template #header>
                    <el-dropdown trigger="click">
                      <span class="ovhidden1 flex mt-5 f333">
                        {{ $t('Order.OrderTableStatus') }}
                        <el-icon>
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                        <el-select
                          v-model="searchPurOrderObj.Status"
                          @change="getPurchaseOrderList"
                          clearable
                          style="width:200px"
                          :placeholder="$t('Order.orderSelectStatus')"
                          class="m-2"
                        >
                          <el-option
                            v-for="item in pOrderStateList"
                            :key="item.code"
                            :label="item.massge"
                            :value="item.code"
                          />
                        </el-select>
                      </template>
                    </el-dropdown>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <el-dropdown trigger="click">
                      <span class="ovhidden1 flex mt-5 f333">
                        {{ $t('Order.OrderVendor') }}
                        <el-icon>
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                        <el-select
                          v-model="searchPurOrderObj.Suppliers"
                          @focus="pubData.getClentAndSupper(1, 1)"
                          @visible-change="pubData.cantPendingRequest"
                          v-Loadmore="pubData.getClentAndSupper1"
                          :remote-method="pubData.remoteClentAndSupper"
                          :loading="selectLoading"
                          @change="getPurchaseOrderList"
                          clearable
                          remote
                          remote-show-suffix
                          filterable
                          :placeholder="$t('Order.orderSelectTheVendor')"
                          style="width:200px"
                        >
                          <el-option
                            v-for="item in SupplierList"
                            :key="item.customer_info_id"
                            :label="item.label"
                            :value="item.value"
                          />
                        </el-select>
                      </template>
                    </el-dropdown>
                  </template>
                  <template #default="{ row }">
                    <span class="ovhidden">
                      {{
                      row.firstname ? `${row.firstname}${row.lastname ? row.lastname : ''}` : '-'
                      }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <el-dropdown trigger="click">
                      <span class="ovhidden1 flex mt-5 f333">
                        {{ $t('Order.OrderTableSales') }}
                        <el-icon>
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                        <!-- 不是销售 -->
                        <el-select
                          v-if="store.type != 2"
                          v-model="searchPurOrderObj.SalesID"
                          @focus="getSalesList"
                          @visible-change="cantPendingRequest"
                          v-Loadmore="getSalesList1"
                          :remote-method="remoteSalesList"
                          :loading="selectLoading1"
                          @change="getPurchaseOrderList"
                          remote
                          remote-show-suffix
                          filterable
                          clearable
                          :placeholder="$t('Order.orderSelectSales')"
                          style="width:200px"
                        >
                          <el-option
                            v-for="item in SalesList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          />
                        </el-select>
                        <!-- 是销售 -->
                        <el-select
                          v-else
                          v-model="searchPurOrderObj.SalesID"
                          @focus="pubData.getCrmUserList(1, 'orders')"
                          @visible-change="pubData.cantPendingRequest"
                          v-Loadmore="pubData.getCrmUserList1"
                          :remote-method="pubData.remoteCrmUserList"
                          :loading="selectLoading"
                          @change="getPurchaseOrderList"
                          remote
                          remote-show-suffix
                          filterable
                          clearable
                          :placeholder="$t('Order.orderSelectSales')"
                          style="width:200px"
                          class="m-2"
                        >
                          <el-option
                            v-for="item in purcharList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          />
                        </el-select>
                      </template>
                    </el-dropdown>
                  </template>
                  <template #default="{ row }">
                    <span class="ovhidden">{{ row.salesName ? row.salesName : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip>
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333">{{ $t('Order.PorderCreatedBy') }}</span>
                    <!-- <el-dropdown trigger="click">
                      <span class="ovhidden1 flex mt-5 f333">
                        {{ $t('Order.PorderCreatedBy') }}
                        <el-icon>
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                      
                        <el-select
                          v-if="store.type != 2"
                          v-model="searchPurOrderObj.purchaseID"
                          @focus="pubData.getCrmUserList(2, 'purchaseorder')"
                          @visible-change="pubData.cantPendingRequest"
                          v-Loadmore="pubData.getCrmUserList1"
                          :remote-method="pubData.remoteCrmUserList"
                          :loading="selectLoading"
                          @change="getPurchaseOrderList"
                          remote
                          remote-show-suffix
                          filterable
                          clearable
                          style="width:200px"
                          :placeholder="$t('Order.orderSelectPurchasers')"
                          class="m-2"
                        >
                          <el-option
                            v-for="item in purcharList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          />
                        </el-select>
                     
                        <el-select
                          v-else
                          v-model="searchPurOrderObj.purchaseID"
                          @focus="getBuyerList"
                          @visible-change="cantPendingRequest"
                          v-Loadmore="getBuyerList1"
                          :remote-method="remoteBuyerList"
                          :loading="selectLoading1"
                          @change="getpurTakeList"
                          remote
                          remote-show-suffix
                          filterable
                          clearable
                          :placeholder="$t('Order.orderSelectPurchasers')"
                          style="width:200px"
                          class="m-2"
                        >
                          <el-option
                            v-for="item in buyerList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          />
                        </el-select>
                      </template>
                    </el-dropdown>-->
                  </template>
                  <template #default="{ row }">
                    <span class="ovhidden">{{ row.create_name ? row.create_name : '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="items" show-overflow-tooltip width="65">
                  <template #header>
                    <span class="ovhidden1 flex mt-5 f333">{{ $t("Order.OrderTableItems") }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Created Date"
                  prop="create_time"
                  width="140"
                  show-overflow-tooltip
                >
                  <template #header>
                    <el-dropdown
                      ref="dateDropdown1"
                      @visible-change="handleVisible1"
                      trigger="click"
                      :hide-on-click="false"
                    >
                      <span class="ovhidden1 flex mt-5 f333">
                        {{ $t('Order.OrderTableCreatedDate') }}
                        <el-icon>
                          <arrow-down />
                        </el-icon>
                      </span>
                      <template #dropdown>
                        <el-date-picker
                          v-model="searchPurOrderObj.PurOrderDate"
                          clearable
                          type="daterange"
                          @focus="dateFocus1"
                          @blur="dateBlur1"
                          @change="chooseDate1"
                          format="YYYY/MM/DD"
                          value-format="YYYY-MM-DD"
                          unlink-panels
                          :range-separator="$t('Order.orderDateTo')"
                          :start-placeholder="$t('Order.orderStartDate')"
                          :end-placeholder="$t('Order.orderEndDate')"
                          :shortcuts="shortcuts"
                          style="width:200px"
                        />
                      </template>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import * as utils from "../utils";
import { HomeStore } from "@/slack/index.js";
import { useRouter } from "vue-router";
import Empty from "./Empty.vue";
import i18n from "@/assets/lang";
import { ElMessage } from "element-plus";
import * as pubData from "./orderData.js";
import { useDemoStore } from "@/pinia/index";
import * as api from "@/api/apiPayOrder/index";
import { Kernaldec } from "@/hooks/useDecrypt";
import { ArrowDown, Search } from "@element-plus/icons-vue";
import {
  ref,
  reactive,
  onMounted,
  onUnmounted,
  computed,
  watch,
  nextTick,
  defineAsyncComponent,
} from "vue";

const router = useRouter();
const store = useDemoStore();

const routerID1 = router.currentRoute.value.query.fromTaskID;
const routerName1 = router.currentRoute.value.query.fromTaskName;

const routerID = router.currentRoute.value.query.fromPorderID;
const routerName = router.currentRoute.value.query.fromPorderName;

// 权限对象
const LimitObj1 = {};
const LimitObj2 = {};

/************ 获取采购任务开始 ************/
const handleCurrentChange = (e) => {
  if (e) {
    HomeStore().selectData = e;
    purOrderTableRef.value.toggleRowSelection(e, true);
  }
};
const handleSelectionChange = (e) => {
  if (e.length > 0) {
    purOrderTableRef.value.setCurrentRow(e[e.length - 1]);
    e.map((item, index) => {
      if (index == e.length - 1) {
        purOrderTableRef.value.toggleRowSelection(item, true);
      } else {
        purOrderTableRef.value.toggleRowSelection(item, false);
      }
    });
  } else {
    purOrderTableRef.value.setCurrentRow("");
    HomeStore().selectData = "";
  }
};
const purTaskObj = reactive({
  loading: true,
  purTaskID: "",
  ReturnpurTaskID: "",
  purTaskState: "",
  purChaser: "",
  purChaserID: "",
  purTakeList: [],
  purTakeNumBer: "",
});
const selectLoading1 = ref(false);
const pendingRequest1 = ref(true);
const cantPendingRequest = (val) => {
  if (!val) {
    pendingRequest1.value = false;
  } else {
    pendingRequest1.value = true;
  }
};
// 获取销售列表
const SalesList = ref(pubData.crmUserList);
const salesData = {
  token: store.token,
  kw: "",
  group: 1,
  page: "",
  pageSize: 30,
};
const getSalesList = () => {
  selectLoading1.value = true;
  SalesList.value = null;
  salesData.kw = "";
  salesData.page = 1;
  api.ocAllSales(salesData).then((res) => {
    selectLoading1.value = false;
    SalesLastPage.value = res.data?.last_page;
    SalesList.value = res.data?.data?.map((item) => {
      item.id = item.id;
      return item;
    });
  });
};

const remoteSalesList = (val) => {
  utils.debounce(500, () => {
    if (salesData.kw == val || !pendingRequest1.value) return false;
    selectLoading1.value = true;
    SalesList.value = null;
    salesData.kw = val;
    salesData.page = 1;
    api.ocAllSales(salesData).then((res) => {
      selectLoading1.value = false;
      SalesLastPage.value = res.data?.last_page;
      SalesList.value = res.data?.data?.map((item) => {
        item.id = item.id;
        return item;
      });
    });
  });
};
const SalesLastPage = ref(0);
const getSalesList1 = () => {
  utils.debounce(500, () => {
    if (salesData.page == SalesLastPage.value || SalesList.value?.length == 0)
      return false;
    salesData.page++;
    api.ocAllSales(salesData).then((res) => {
      SalesLastPage.value = res.data?.last_page;
      SalesList.value = [
        ...SalesList.value,
        ...res.data?.data?.map((item) => {
          item.id = item.id;
          return item;
        }),
      ];
    });
  });
};

// 获取采购员列表
const buyerList = ref([]);
const buyerLastPage = ref("");
const buyerdata = { token: store.token, kw: "", page: "" };
const getBuyerList = (val) => {
  selectLoading1.value = true;
  buyerList.value = null;
  buyerdata.kw = "";
  buyerdata.page = 1;
  api.ocAllPurchaser(buyerdata).then((res) => {
    selectLoading1.value = false;
    buyerLastPage.value = res.data?.last_page;
    buyerList.value = res.data?.data;
  });
};
const remoteBuyerList = (val) => {
  utils.debounce(500, () => {
    if (buyerdata.kw == val || !pendingRequest1.value) return false;
    selectLoading1.value = true;
    buyerList.value = null;
    buyerdata.kw = val;
    buyerdata.page = 1;
    api.ocAllPurchaser(buyerdata).then((res) => {
      selectLoading1.value = false;
      buyerLastPage.value = res.data?.last_page;
      buyerList.value = res.data?.data;
    });
  });
};
const getBuyerList1 = () => {
  utils.debounce(500, () => {
    if (buyerdata.page == buyerLastPage.value || buyerList.value.length == 0)
      return false;
    buyerdata.page++;
    api.ocAllPurchaser(buyerdata).then((res) => {
      buyerLastPage.value = res.data?.last_page;
      buyerList.value = [...buyerList.value, ...res.data?.data];
    });
  });
};

/************ 时间方法开始 ************/
const dateDropdown = ref();
const isCloseState = ref(false);
const handleVisible = () => {
  //下拉菜单展开 关闭时触发
  if (isCloseState.value) {
    dateDropdown.value.handleOpen();
  } else {
    isCloseState.value = false;
  }
};
const chooseDate = (e) => {
  //用户确认选定的值时触发
  isCloseState.value = false;
  dateDropdown.value.handleClose();
  getpurTakeList();
};
const dateBlur = () => {
  //失去焦点时触发
  isCloseState.value = false;
  dateDropdown.value.handleClose();
};
const dateFocus = () => {
  //获得焦点时触发
  isCloseState.value = true;
};
/************ 时间方法开始 ************/
const searchPurTaskObj = reactive({
  purchaseID: store.type != 2 ? String(store.user_uid) : "",
  salesID: store.type == 2 ? String(store.user_uid) : "",
  Status: "",
  putTaskDate: [],
  Keyword: "",
  model: "",
  purOrderName: "",
});
const takedata = {
  token: store.token,
  page: 1,
  pageSize: 20,
  is_team: 1,
  Purchaseordertesk_id: "",
  PI_name: "",
  State: "",
  sale_id: "",
  purchaser_id: "",
  start_time: "",
  end_time: "",
  keyword: "",
  model: "",
};
const getpurTakeList = (info) => {
  selectList.value = []; //搜索前清空选中的数组
  purTaskObj.loading = true;
  purTaskObj.purTaskID = ""; //获取时清空选中id
  takedata.page = 1;
  takedata.keyword = info == "router" ? "" : searchPurTaskObj.Keyword; //有路由为空
  takedata.Purchaseordertesk_id = info == "router" ? routerID1 : ""; //只有路由可用
  takedata.State = searchPurTaskObj.Status;
  takedata.sale_id = searchPurTaskObj.salesID;
  takedata.model = searchPurTaskObj.model;
  searchPurTaskObj.purchaseID =
    info == "router" ? "" : searchPurTaskObj.purchaseID;
  takedata.purchaser_id = info == "router" ? "" : searchPurTaskObj.purchaseID; //有路由时不已采购搜索
  takedata.PI_name = searchPurTaskObj.purOrderName; //精确搜索
  takedata.start_time = searchPurTaskObj.putTaskDate
    ? searchPurTaskObj.putTaskDate[0]
    : "";
  takedata.end_time = searchPurTaskObj.putTaskDate
    ? searchPurTaskObj.putTaskDate[1]
    : "";
  api.purchaseOrderTakeList(takedata).then((res) => {
    purTaskObj.loading = false;
    lastPage.value = res.data?.last_page;
    purTaskObj.purTakeNumBer = res.data?.total ? res.data?.total : 0;
    purTaskObj.purTakeList = res.data?.data?.map((item) => {
      item.checkState = false;
      return item;
    });
    purTaskObj.purTakeList = purTaskObj.purTakeList?.length
      ? purTaskObj.purTakeList
      : [];
    if (info == "router") {
      purTaskObj.purTaskID = purTaskObj.purTakeList[0]?.purchaseordertesk_id;
      purTaskObj.ReturnpurTaskID =
        purTaskObj.purTakeList[0]?.purchaseordertesk_id;
      purTaskObj.purChaser = purTaskObj.purTakeList[0]?.purchaser;
      purTaskObj.purTaskState = purTaskObj.purTakeList[0]?.State;
      purTaskObj.purChaserID = purTaskObj.purTakeList[0]?.purchase_id;
      purTaskObj.purTakeList?.forEach((item, index) => {
        if (index == 0 && item.State == 1) {
          item.checkState = true;
          selectList.value = [];
          SelectionMethod(item, 2);
        }
      });
    }
  });
};
// 上拉加载
const lastPage = ref("");
const getpurTakeList1 = () => {
  if (purTaskObj.purTakeList?.length == 0 || lastPage.value == takedata.page)
    return false;
  takedata.page++;
  api.purchaseOrderTakeList(takedata).then((res) => {
    lastPage.value = res.data?.last_page;
    purTaskObj.purTakeList = [
      ...purTaskObj.purTakeList,
      ...res.data?.data?.map((item) => {
        item.checkState = false;
        return item;
      }),
    ];
  });
};

//模糊搜索
const inputKeyword = () => {
  utils.debounce(500, () => {
    getpurTakeList();
  });
};
//精确搜索
const purTaskAction = ref();
const cancelRemove1 = () => {
  purTaskAction.value.hide();
};

const searchState1 = ref(false);
const extraTaskOpen = () => {
  searchState1.value = true;
  cancelRemove1();
  purcharList.value = [
    { name: store.UserGroupName, id: String(store.user_uid) },
  ]; //防止关闭后数据清空
};

const resetSearchTaskWin = () => {
  searchPurTaskObj.model = "";
  searchPurTaskObj.putTaskDate = [];
  searchPurTaskObj.salesID = "";
  searchPurTaskObj.Keyword = "";
  searchPurTaskObj.Status = "";
  searchPurTaskObj.purchaseID = "";
  searchPurTaskObj.purOrderName = "";
};
const searchTaskWin = () => {
  getpurTakeList();
  searchState1.value = false;
};
/************ 获取采购任务结束 ************/

/************  页面切换开始 ************/
const purTaskRef = ref();
const purOrderTableRef = ref();
let selectList1 = [];
let selectList2 = [];
const isTransaction = (val) => {
  store.changepOrderShow(val);
  if (!val) {
    //第二页面切换第一页面查出与当前id数据，清空选项数组
    selectList1 = selectList.value?.filter(
      (item) => item.purchaseordertesk_id == purTaskObj.purTaskID
    );
    selectList.value = [];
    selectList2 = purOrderObj.selectList?.filter(
      (item) => item.purchaseorder_id == purOrderObj.purOrderID
    );
    purOrderObj.selectList = [];
  } else {
    //第一页面切换第二页面有原id数组赋值给选项数组，恢复第二页面原id项
    selectList.value = selectList1?.length == 1 ? selectList1 : [];
    purTaskObj.purTakeList?.forEach((item, index) => {
      if (
        item.purchaseordertesk_id == purTaskObj.purTaskID &&
        item.State == 1
      ) {
        item.checkState = true;
      }
    });
    purOrderObj.selectList = selectList2?.length == 1 ? selectList2 : [];
    purOrderObj.purOrderList?.forEach((item, index) => {
      if (item.purchaseorder_id == purOrderObj.purOrderID) {
        item.checkState = true;
      }
    });
  }
};
const takeListRef = ref();
const takeListItemRef = ref();
const getPurTaskID = (val) => {
  if (
    !!purTaskObj.purTaskID &&
    purTaskObj.purTaskID == val.purchaseordertesk_id
  ) {
    purTaskObj.purTaskID = "";
    purTaskObj.purTakeList?.forEach((item) => (item.checkState = false));
    selectList.value = []; //第二次点击取消选中后清空数组
  } else {
    purTaskObj.purTaskID = val.purchaseordertesk_id;
    purTaskObj.purTakeList?.forEach((item) => {
      if (purTaskObj.purTaskID == item.purchaseordertesk_id && val.State == 1) {
        //单选时选择不同的采购单清空勾选数组
        item.checkState = true;
      } else {
        item.checkState = false;
      }
    });
    selectList.value = []; //切换采购单先清空数组，避免不同采购禁止选择
    SelectionMethod(val, 2);
  }
  purTaskObj.ReturnpurTaskID = val.purchaseordertesk_id;
  purTaskObj.purChaser = val.purchaser;
  purTaskObj.purTaskState = val.State;
  purTaskObj.purChaserID = val.purchase_id;
  if (!store.pOrderShow) {
    takeListItemRef.value.forEach((item) => {
      nextTick(() => {
        if (item.className == "success-row item flex aic jc-sb") {
          takeListRef.value.scrollTo({
            top: item.offsetTop - 72,
            behavior: "smooth",
          });
        }
      });
    });
  }
  store.changepOrderShow(true);
};
const purOrderRef = ref();
const purOrderitemRef = ref();
const getPurOrderID = (val) => {
  purOrderObj.purOrderID = val.purchaseorder_id;
  purOrderObj.porderState = val.State;
  purOrderObj.purLoading = true;
  purOrderObj.current = "";
  purOrderObj.purOrderList?.forEach((item) => {
    if (val.purchaseorder_id == item.purchaseorder_id && item) {
      //单选时选择不同的采购单清空勾选数组
      item.checkState = true;
    } else {
      item.checkState = false;
    }
  });
  purOrderObj.selectList = []; //切换采购单先清空数组，避免不同采购禁止选择
  SelectionMethod1(val, 2);
  if (!store.pOrderShow) {
    purOrderitemRef.value.forEach((item) => {
      nextTick(() => {
        if (item.className == "success-row item flex aic jc-sb") {
          purOrderRef.value.scrollTo({
            top: item.offsetTop - 490,
            behavior: "smooth",
          });
        }
      });
    });
  }
  store.changepOrderShow(true);
};
watch(
  () => store.pOrderShow,
  () => {
    if (store.pOrderShow) {
      purTaskRef.value.clearSelection();
      purOrderTableRef.value.clearSelection();
    } else {
      purTaskObj.purTakeList?.forEach((item) => (item.checkState = false));
      purOrderObj.purOrderList?.forEach((item) => (item.checkState = false));
    }
  }
);
/************  页面切换结束 ************/

/************ 删除采购任务开始 ************/
const delPurTaskItemsRef = ref();
const delPurTaskItemsRef1 = ref();
const closePurTaskItem = () => {
  delPurTaskItemsRef.value.hide();
};
const closePurTaskItem1 = () => {
  delPurTaskItemsRef1.value.hide();
  changeTaskStete("Cancel");
};
const delPurTaskItems = () => {
  delPurTaskItemsRef.value.hide();
  delPurTaskItemsRef1.value.hide();
  if (selectList.value && selectList.value?.length == 0) {
    ElMessage({
      type: "info",
      message: i18n.global.t("Order.orderPleasePurchaseTask"),
    });
    return false;
  }
  const data = {
    token: store.token,
    Purchaseordertesk_ids: selectList.value?.map(
      (item) => item.purchaseordertesk_id
    ),
  };
  api.purchaseOrderteskDelete(data).then((res) => {
    if (res.Status == 0) {
      getpurTakeList();
      ElMessage({
        type: "success",
        message: i18n.global.t("success.OrederDeletedSuccess"),
      });
    }
  });
};
/************ 删除采购任务结束 ************/

/************ 新建采购单开始 ************/
const selectList = ref([]);
const SelectionMethod = (val, type) => {
  if (type == 2) {
    if (
      (selectList.value?.length > 0 &&
        val.purchase_id != selectList.value[0]?.purchase_id) ||
      val.State != 1
    )
      return false; //采购人不一致、状态不对不添加至选中数组
    if (
      selectList.value?.some(
        (item) => item.purchaseordertesk_id == val.purchaseordertesk_id
      )
    ) {
      //多选框再次点击表示删除
      selectList.value?.splice(
        selectList.value?.findIndex(
          (item) => item.purchaseordertesk_id == val.purchaseordertesk_id
        ),
        1
      );
    } else {
      selectList.value.push(val);
    }
  } else {
    selectList.value = val;
  }
};

// 采购中的任务禁选
const callback = (row, index) => {
  if (selectList.value?.length == 0) {
    if (row.State == 1) {
      return true;
    } else {
      return false;
    }
  } else {
    if (row.State == 1 && row.purchase_id == selectList.value[0]?.purchase_id) {
      return true;
    } else if (
      row.State != 1 ||
      row.purchase_id != selectList.value[0]?.purchase_id
    ) {
      return false;
    }
  }
};

const createNewPurchaserOrderRef = ref();
const newPurOpen = () => {
  if (selectList.value && selectList.value?.length == 0) {
    ElMessage({
      type: "info",
      message: i18n.global.t("Order.orderPleaseEnterTask"),
    });
    return false;
  }
  createNewPurchaserOrderRef.value.newPurOrderState = true;
};
// 汇率
const rateList = ref({});
const rateListRequest = () => {
  api.paymentGetrate({ token: store.token }).then((res) => {
    rateList.value = res.data && res.data;
    rateList.value["CNY"] = 1;
  });
};
// 录单后改变采购任务状态和产品数量
const PurchaseRightRef = ref();
const changeTaskStete = (val) => {
  purTaskRef.value?.clearSelection();
  purTaskObj.purTakeList.forEach((item) => {
    if (item.purchaseordertesk_id != purTaskObj.purTaskID) {
      item.checkState = false;
    }
  });
  selectList.value = selectList.value?.filter((item) => item.checkState);
  if (val == "Save") {
    getpurTakeList();
    store.changepOrderShow(true);
  }
};
/************  新建采购单结束 ************/
/************ 采购任务操作开始 ************/
const returnTask = (val, isTrue) => {
  // 退回采购任务刷新列表数据
  purTaskObj.purTakeList?.forEach((item, index) => {
    if (item.purchaseordertesk_id == purTaskObj.purTaskID) {
      if (val == item.items && !isTrue) {
        //全部退回无采购任务
        purTaskObj.purTakeList?.splice(index, 1);
        purTaskObj.purTaskID =
          purTaskObj.purTakeList[index].purchaseordertesk_id;
      } else {
        getpurTakeList();
        purTaskObj.purTaskID = purTaskObj.ReturnpurTaskID;
      }
    }
  });
  PurchaseRightRef.value.getTakeDetail();
};

/************ 采购任务操作结束 ************/

/************ 获取采购订单开始 ************/
const purOrderObj = reactive({
  loading: true,
  purOrderID: "",
  purOrderNumber: "",
  porderState: "",
  purLoading: true,
  purOrderList: [],
  selectList: [],
  PurOrderName: "",
  current: "",
});

/************ 时间方法开始 ************/
const dateDropdown1 = ref();
const isCloseState1 = ref(false);
const handleVisible1 = () => {
  //下拉菜单展开 关闭时触发
  if (isCloseState1.value) {
    dateDropdown1.value.handleOpen();
  } else {
    isCloseState1.value = false;
  }
};
const chooseDate1 = () => {
  //用户确认选定的值时触发
  isCloseState1.value = false;
  dateDropdown1.value.handleClose();
  getPurchaseOrderList();
};
const dateBlur1 = () => {
  //失去焦点时触发
  isCloseState1.value = false;
  dateDropdown1.value.handleClose();
};
const dateFocus1 = () => {
  //获得焦点时触发
  isCloseState1.value = true;
};
/************ 时间方法结束 ************/

/************ 获取关联任务详情id开始 ************/
const TaskDetailIDList = ref([]);
const getTaskDetailID = (val) => {
  TaskDetailIDList.value = val;
};
/************ 获取关联任务详情id结束 ************/
const purorderdata = {
  token: store.token,
  page: 1,
  pageSize: 20,
  purchaseorder_id: "",
  Purchaseordername: "",
  sale_id: "",
  is_team: 1,
  State: "",
  supplier_id: "",
  start_time: "",
  end_time: "",
  keyword: "",
  model: "",
  creat_id: "",
  Purchaseordertesk_detailed_id: [],
};
const purLastPage = ref("");
const getPurchaseOrderList = (info) => {
  purOrderObj.selectList = []; //获取前先清空选中数组
  purOrderObj.loading = true;
  purOrderObj.purOrderID = ""; //先清空后赋值
  purorderdata.page = 1;
  purorderdata.model = searchPurOrderObj.model;
  purorderdata.State = searchPurOrderObj.Status;
  purorderdata.sale_id = searchPurOrderObj.SalesID;
  purorderdata.supplier_id = searchPurOrderObj.Suppliers;
  searchPurOrderObj.purchaseID =
    info == "router" ? "" : searchPurOrderObj.purchaseID;
  purorderdata.creat_id = info == "router" ? "" : searchPurOrderObj.purchaseID;
  purorderdata.Purchaseordername = searchPurOrderObj.porderName;
  purorderdata.keyword = info == "router" ? "" : searchPurOrderObj.Keyword;
  purorderdata.purchaseorder_id = info == "router" ? routerID : "";
  purorderdata.start_time = searchPurOrderObj.PurOrderDate
    ? searchPurOrderObj.PurOrderDate[0]
    : "";
  purorderdata.end_time = searchPurOrderObj.PurOrderDate
    ? searchPurOrderObj.PurOrderDate[1]
    : "";
  purorderdata.Purchaseordertesk_detailed_id = TaskDetailIDList.value?.map(
    (item) => item.Purchaseordertesk_detailed_id
  );
  api.purchaseOrderList(purorderdata).then((res) => {
    purOrderObj.loading = false;
    purLastPage.value = res.data?.last_page;
    purOrderObj.purOrderNumber = res.data?.total ? res.data?.total : 0;
    purOrderObj.purOrderList = res.data?.data?.map((item) => {
      item.salesName = "";
      item.checkState = false;
      item.sale = item.sale?.map((obj) => {
        obj = obj ? obj : "-";
        return obj;
      });
      item.salesName = item.sale?.toString();
      item.firstname = Kernaldec(item.firstname);
      item.lastname = Kernaldec(item.lastname);
      return item;
    });
    if (
      purTaskObj.purTaskID &&
      !!purorderdata.Purchaseordertesk_detailed_id?.length
    ) {
      purOrderObj.purOrderID =
        purOrderObj.purOrderList?.length &&
        purOrderObj.purOrderList[0]?.purchaseorder_id;
      purOrderObj.porderState =
        purOrderObj.purOrderList?.length && purOrderObj.purOrderList[0]?.State;
      purOrderObj.purLoading = false;
      purOrderObj.purOrderList?.forEach((item, index) => {
        if (index == 0) {
          item.checkState = true;
        }
      });
    }
    if (info == "router" || info == "new") {
      purOrderObj.purOrderID =
        purOrderObj.purOrderList?.length &&
        purOrderObj.purOrderList[0]?.purchaseorder_id;
      purOrderObj.porderState =
        purOrderObj.purOrderList?.length && purOrderObj.purOrderList[0]?.State;
      purOrderObj.purLoading = true;
      purOrderObj.purOrderList?.forEach((item, index) => {
        if (index == 0) {
          item.checkState = true;
          purOrderObj.selectList = [];
          SelectionMethod1(item, 2);
        }
      });
    }
  });
};
const getPurchaseOrderList1 = () => {
  if (
    purOrderObj.purOrderList?.length == 0 ||
    purorderdata.page == purLastPage.value
  )
    return false;
  purorderdata.page++;
  api.purchaseOrderList(purorderdata).then((res) => {
    purLastPage.value = res.data?.last_page;
    purOrderObj.purOrderList = [
      ...purOrderObj.purOrderList,
      ...res.data?.data?.map((item) => {
        item.salesName = "";
        item.checkState = false;
        item.sale = item.sale?.map((obj) => {
          obj = obj ? obj : "-";
          return obj;
        });
        item.salesName = item.sale?.toString();
        item.firstname = Kernaldec(item.firstname);
        item.lastname = Kernaldec(item.lastname);
        return item;
      }),
    ];
  });
};

const searchPurOrderObj = reactive({
  Keyword: "",
  Status: "",
  Suppliers: "",
  SalesID: store.type == 2 ? String(store.user_uid) : "",
  purchaseID: store.type != 2 ? String(store.user_uid) : "",
  model: "",
  porderName: "",
  PurOrderDate: [],
});

//模糊搜索
const inputKeyword1 = () => {
  utils.debounce(500, () => {
    getPurchaseOrderList();
  });
};

// 根据任务id搜索
const isTaskState = ref(0);
watch(TaskDetailIDList, () => {
  if (isTaskState.value == 0) {
    isTaskState.value = 1;
    return false;
  }
  getPurchaseOrderList();
});

// 精确搜索
const extraOpen = () => {
  searchState2.value = true;
  cancelRemove();
  purcharList.value = [
    { name: store.UserGroupName, id: String(store.user_uid) },
  ];
};
const searchState2 = ref(false);
const searchWin2 = () => {
  getPurchaseOrderList();
  searchState2.value = false;
};
const resetSearchWin2 = () => {
  searchPurOrderObj.Status = "";
  searchPurOrderObj.PurOrderDate = [];
  searchPurOrderObj.model = "";
  searchPurOrderObj.SalesID = "";
  searchPurOrderObj.porderName = "";
  searchPurOrderObj.Suppliers = "";
};
/************ 获取采购订单结束 ************/

/************ 删除采购订单开始 ************/
const SelectionMethod1 = (val, type) => {
  if (type == 2) {
    if (
      purOrderObj.selectList?.some(
        (item) => item.purchaseorder_id == val.purchaseorder_id
      )
    ) {
      //多选框再次点击表示删除
      purOrderObj.selectList?.splice(
        purOrderObj.selectList?.findIndex(
          (item) => item.purchaseorder_id == val.purchaseorder_id
        ),
        1
      );
    } else {
      purOrderObj.selectList?.push(val);
    }
  } else {
    purOrderObj.selectList = val;
  }
};

const delPurOrderRef = ref();
const closePurOrderRef = () => {
  delPurOrderRef.value.hide();
};
const delPurOrderRef1 = ref();
const closePurOrderRef1 = () => {
  delPurOrderRef1.value.hide();
  purOrderObj.purOrderList.forEach((item) => {
    if (item.purchaseorder_id != purOrderObj.purOrderID) {
      item.checkState = false;
    }
  });
  purOrderObj.selectList = purOrderObj.selectList?.filter(
    (item) => item.checkState
  );
};
const delOrderItems = () => {
  delPurOrderRef.value.hide();
  delPurOrderRef1.value.hide();
  if (purOrderObj.selectList?.length == 0) {
    ElMessage({
      type: "info",
      message: i18n.global.t("Order.orderPleaseSelectPurchaseOrder"),
    });
    return false;
  }
  const data = {
    token: store.token,
    purchaseorder_ids: purOrderObj.selectList?.map(
      (item) => item.purchaseorder_id
    ),
  };
  api.purchaseOrderDelete(data).then((res) => {
    if (res.Status == 0) {
      ElMessage({
        type: "success",
        message: i18n.global.t("success.OrederDeletedSuccess"),
      });
      purOrderObj.selectList?.forEach((item) => {
        let index = purOrderObj.purOrderList?.findIndex(
          (obj) => obj.purchaseorder_id == item.purchaseorder_id
        );
        purOrderObj.purOrderList?.splice(index, 1);
        purOrderObj.purOrderID = purOrderObj.purOrderList?.length
          ? purOrderObj.purOrderList[index].purchaseorder_id
          : "";
      });
      purOrderObj.selectList = [];
      // 刷新采购任务状态和详情
      if (purTaskObj.purTaskID) {
        purTaskObj.purTakeList?.forEach((item, index) => {
          if (item.purchaseordertesk_id == purTaskObj.purTaskID) {
            item.state_text = i18n.global.t("Order.pOrderStateTobepurchased");
            item.State = 1;
          }
        });
        PurchaseRightRef.value.getTakeDetail();
      }
    }
  });
};
/************ 删除采购订单结束 ************/

/************ 删除采购单详情刷新采购订单列表开始 ************/
const delItemRefresh = () => {
  let index = purOrderObj.purOrderList?.findIndex(
    (item) => item.purchaseorder_id == purOrderObj.purOrderID
  );
  purOrderObj.purOrderList?.splice(index, 1);
  purOrderObj.purOrderID = purOrderObj.purOrderList[index].purchaseorder_id;
};

/************ 删除采购单详情刷新采购订单列表结束 ************/
/************ 采购单操作下拉框开始 ************/
const purOrderAction = ref();
const cancelRemove = () => {
  purOrderAction.value.hide();
};
//导出采购单
const outPutPurOrderRef = ref();
const outPutOpen = () => {
  outPutPurOrderRef.value.outPutOrderState = true;
  cancelRemove();
};
// 设置
const settleOpen = () => {
  cancelRemove();
};
/************ 采购单操作下拉框结束 ************/
/************ 详情部分遮罩开始 ************/
const maksStateObj = reactive({ taskState: false, purOrderState: false });
const changeTaskState = (val) => {
  maksStateObj.taskState = val;
};
const changePurOrderState = (val) => {
  maksStateObj.purOrderState = val;
};
/************ 详情部分遮罩开始 ************/

/************ 公共数据列表开始 ************/
const takeStateList = computed(() => {
  //采购任务状态列表
  return [
    { code: 1, massge: i18n.global.t("Order.pOrderStateTobepurchased") },
    { code: 2, massge: i18n.global.t("Order.pOrderStateInprocurement") },
    { code: 3, massge: i18n.global.t("Order.pOrderStatePurchasecompleted") },
  ];
});
const pOrderStateList = computed(() => {
  //采购单状态列表
  return [
    { code: 1, massge: i18n.global.t("Order.pOrderStateTobepaid") },
    { code: 2, massge: i18n.global.t("Order.pOrderStatePaid") },
    { code: 3, massge: i18n.global.t("Order.pOrderStateWaitingforarrival") },
    { code: 4, massge: i18n.global.t("Order.pOrderStatePurchasecompleted") },
  ];
});
/************ 公共数据列表结束 ************/
/************ 获取公共数据列表开始 ************/
const SupplierList = ref(pubData.clentAndSupperList);
const selectLoading = ref(pubData.selectLoading);
const purcharList = ref(pubData.crmUserList);
const shortcuts = ref(pubData.shortcuts);
const modelList = ref(pubData.modelList);
/************ 获取公共数据列表结束 ************/

//视口
const windowWidth = ref(window.innerWidth);
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};
watch(windowWidth, () => {
  if (windowWidth.value < 1745) {
    store.changeState(true);
  }
});

const isShowTooltip = ref(true);
const getWidth = (event) => {
  if (event.target.scrollWidth > event.target.clientWidth) {
    isShowTooltip.value = false;
  } else {
    isShowTooltip.value = true;
  }
};
onMounted(() => {
  if (routerID) {
    store.changepOrderShow(true);
    searchPurOrderObj.Keyword = routerName;
    getpurTakeList();
    getPurchaseOrderList("router");
  } else if (routerID1) {
    store.changepOrderShow(true);
    searchPurTaskObj.Keyword = routerName1;
    getpurTakeList("router");
  } else {
    getpurTakeList();
    getPurchaseOrderList();
    purcharList.value = [
      { name: store.UserGroupName, id: String(store.user_uid) },
    ];
  }
  rateListRequest();
  // window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  // window.removeEventListener("resize", handleResize);
});
</script>
<style lang="less" scoped>
@import "./less/pubTableCss.less";
@import "./less/purchaseOrder.less";
</style>